import {
    Box,
    Center,
    Text,
    Button,
    VStack,
    HStack,
} from '@chakra-ui/react';
import Form from "react-validation/build/form";
import React, { useState, useEffect } from "react";
import { useParams, Link } from 'react-router-dom';
import { HorizontalBar, Pagination, PaginationButton } from "./style";
import "../index.css";
import Select from "react-select";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import APIConfig from "../../api/APIConfig";
import swal from 'sweetalert';
import ReactLoading from "react-loading";


function PartisipanAktif() {
    const [lowongan, setLowongan] = useState([]);
    const [statusPenerimaan, setStatusPenerimaan] = useState('');
    const [statusPembayaran, setStatusPembayaran] = useState('');
    const [peserta, setPeserta] = useState([]);
    const [spinner, setSpinner] = useState(false); 

    const { id } = useParams();
    
    const optionKategori = [ 
        { value: 0, label: "--Pilih Status--" },
        { value: 1, label: "Diterima" },
        { value: 2, label: "Ditolak" },
        { value: 3, label: "Menunggu Konfirmasi" },
    ]

    const [selectedValue, setSelectedValue] = useState(0);

    const handleSearchKategori = (e) => {
        setSelectedValue(e.value);
    };

    const matcher = (data) => {
        console.log(selectedValue)

        if (selectedValue === 0) return true;
       else if (selectedValue === 1) {
            if (data.statusPenerimaan.includes("Diterima")) {
                console.log("masuk sini")
                return true;
            } 
            
        } else if (selectedValue === 2) {
            if (data.statusPenerimaan.includes("Ditolak")) {
                return true;
            }
        } else if (selectedValue === 3) {
            if (data.statusPenerimaan.includes("Menunggu Konfirmasi")) {
                return true
            };
        }
        return false;
    };

    let data = lowongan;

    data = data.filter((i) => matcher(i));

    const getProposal = async(idMitra) => {  
        setSpinner(true);
        const response = await APIConfig.get(`/v1/list-lowonganpeserta/mitra/${idMitra}`);
        const result = await response.data;
        setLowongan(result);
        setStatusPembayaran(result.statusPembayaran);
        setStatusPenerimaan(result.statusPenerimaan);
        setPeserta(result.peserta);
        setSpinner(false);

    };

    const terimaLowongan = async(e, id) => {  
        e.preventDefault();

        swal("Apakah anda yakin untuk menerima peserta ini?", {
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Kembali",
                value: "no"
                }
        }
        }).then((value) => {
            if (value === "yes") {
                APIConfig.put(`/v1/lowonganPeserta/statusPenerimaan/${id}`, {
                    statusPenerimaan: "Diterima"
                })
                swal({
                    title: "Peserta berhasil diterima",
                    icon: "success",
                    button: "OK",
                })
                .then(() => {
                    window.location.reload();
                })
                .catch((error) => {
                    console.log(error);
                })
            } 
            return false;
        });
    };

    const tolakLowongan = async(e, id) => {  
        e.preventDefault();
        swal("Apakah anda yakin untuk menolak peserta ini?", {
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Kembali",
                value: "no"
                }
        }
        }).then((value) => {
            if (value === "yes") {
                APIConfig.put(`/v1/lowonganPeserta/statusPenerimaan/${id}`, {
                    statusPenerimaan: "Ditolak"
                })
                swal({
                    title: "Peserta berhasil ditolak",
                    icon: "success",
                    button: "OK",
                })
                .then(() => {
                    window.location.reload();
                })
                .catch((error) => {
                    console.log(error);
                })
            } 
            return false;
        });
    };

    
    useEffect(() => {
        getProposal(id);
    }, []);

    const [currentPage, setCurrentPage] = useState(1);
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(data.length / 10); i++) {
        pageNumbers.push(i);
    }

    const indexOfLastData = currentPage * 10;
    const indexOfFirstData = indexOfLastData - 10;
    data = data.slice(indexOfFirstData, indexOfLastData);

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
      }


    return(
        <div className="container">
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'} pb={20}>
            <Text
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}>
                Partisipan Aktif
            </Text>

            <HStack pt={10} pr={10} justifyContent={"space-between"}>
            <Select
                   borderRadius="10%"
                   fontSize='13px'
                   pt={6}
                   pb={3}
                   border='1px solid #F5F5F5'
                   width='25%'
                   height='40px' 
                   id='kategori' 
                   options={optionKategori}
                   onChange={handleSearchKategori}
                   value={optionKategori.find((obj) => obj.value === selectedValue)}
                   // onChange={this.onChangeKategori.bind(this)}
                   // value={optionKategori.find((obj) => obj.value === this.state.kategori)}
                   placeholder="Status" />
            </HStack>
            
            <Box
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                alignContent={'center'}
                // bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={2}
                overflow={'hidden'}>
                <VStack align='center'>
                    {lowongan.length > 0 ? 
                        <Table style={{width: '100%', margin: '5px'}}>
                            <Thead className="head">
                                <Tr>
                                <Th className='layout'><p className='layoutp'>Nama</p></Th>
                                <Th className='layout'><p className='layoutp'>Email</p></Th>
                                <Th className='layout'><p className='layoutp'>Aktivitas</p></Th>
                                <Th className='layout'><p className='layoutp'>Posisi</p></Th>
                                <Th className='layout'><p className='layoutp'>Status Penerimaan</p></Th>
                                <Th className='layout'><p className='layoutp'>Status Pembayaran</p></Th>
                                <Th className='layout'><p className='layoutp'>Dokumen</p></Th>
                                <Th className='layout'><p className='layoutp'>Terima</p></Th>
                                <Th className='layout'><p className='layoutp'>Tolak</p></Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {data.map((data)=>
                                    <Tr>
                                    <Td className='layout'><p className='layoutp'>{data.peserta.namaPeserta}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.peserta.user.emailUser}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.lowongan.proposal.namaProposal}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.lowongan.proposal.namaPosisi}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.statusPenerimaan}</p></Td>
                                    <Td className='layout'><p className='layoutp'>{data.statusPembayaran}</p></Td>
                                    <Td>        
                                        <Link to={`/mitra/profile/dokumenPartisipan/${data.idLowonganPeserta}`} style={{textDecoration: 'none'}}>
                                        <Button 
                                            size='xs' rounded={'xl'} background='#6554C0' color='#FFFFFF' variant='solid' fontSize={'xs'} margin={'0 10px'}>
                                            Lihat
                                        </Button>
                                        </Link>
                                    </Td>
                                    {data.statusPenerimaan === "Menunggu konfirmasi" ? 
                                    <Td> 
                                        <Form p={6}>
                                        <Button 
                                            onClick={(e) => terimaLowongan(e, data.idLowonganPeserta)}
                                            type='submit'
                                            size='xs' rounded={'xl'} colorScheme='green' variant='solid' fontSize={'xs'} margin={'0 10px'}>
                                            Terima
                                        </Button>
                                        </Form>
                                    </Td>
                                    : <Td></Td>
                                    }
                                    {data.statusPenerimaan === "Menunggu konfirmasi" ? 
                                    <Td>       
                                        <Form p={6}>
                                        <Button 
                                            onClick={(e) => tolakLowongan(e, data.idLowonganPeserta)}
                                            type='submit'
                                            size='xs' rounded={'xl'} colorScheme='red' variant='solid' fontSize={'xs'} margin={'0 10px'}>
                                            Tolak
                                        </Button>
                                        </Form>
                                    </Td>
                                    : <Td></Td>
                                    }
                                </Tr>
                                )}
  
                            </Tbody>
                        </Table>
                    : 
                    <Text fontSize={"large"} fontWeight={'600'}>Belum ada peserta yang melamar ke satupun lowongan Anda</Text>
                    }
                    {data.length > 0 ? (<HorizontalBar last={true} />) : null}
                                {pageNumbers.length > 1 && (
                                    <Pagination
                                    style={{margin: 'auto'}}>
                                        <PaginationButton onClick={() => 
                                            setCurrentPage(1)}>
                                            &lt;&lt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => 
                                            currentPage === 1 ? setCurrentPage(1) : setCurrentPage(currentPage-1)}>
                                            &lt;
                                        </PaginationButton>
                                        {pageNumbers.map((page) => (
                                            <PaginationButton
                                                unshow={
                                                    currentPage > 2 && pageNumbers.length - currentPage > 1
                                                    ? Math.abs(currentPage - page) > 2
                                                    : pageNumbers.length - currentPage < 2
                                                    ? pageNumbers.length - page > 4
                                                    : page > 5
                                                }
                                                active={currentPage === page}
                                                onClick={() => setCurrentPage(page)}
                                                >
                                                    {page}
                                            </PaginationButton>
                                        ))}
                                        <PaginationButton
                                            onClick={() =>
                                            currentPage === pageNumbers.length
                                                ? setCurrentPage(pageNumbers.length)
                                                : setCurrentPage(currentPage + 1)
                                            }
                                        >
                                            &gt;
                                        </PaginationButton>
                                        <PaginationButton onClick={() => setCurrentPage(pageNumbers.length)}>
                                            &gt;&gt;
                                        </PaginationButton>
                                    </Pagination>
                                )}
                </VStack>
            </Box>
            </VStack>
            </Center>
        </div>   
    );
}

export default PartisipanAktif;